module.exports = __webpack_public_path__ + "img/banner3.72b0a0c6.png";